import { type Config } from 'tailwindcss'
import typographyPlugin from '@tailwindcss/typography'
import animatePlugin from 'tailwindcss-animate'
import radixPlugin from 'tailwindcss-radix'
import { extendedTheme } from './app/utils/extended-theme.ts'

export default {
  content: ['./app/**/*.{ts,tsx,jsx,js}'],
  darkMode: 'class',
  theme: {
    container: {
      center: true,
      padding: '2rem',
      screens: {
        // Custom breakpoint
        '3xl': '3840px',
      },
    },
    extend: extendedTheme,
  },
  plugins: [animatePlugin, radixPlugin, typographyPlugin],
} satisfies Config
